/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CheckboxFieldFromJSON, CheckboxFieldToJSON, } from './CheckboxField';
import { PosTerminalFromJSON, PosTerminalToJSON, } from './PosTerminal';
import { RadioboxFieldFromJSON, RadioboxFieldToJSON, } from './RadioboxField';
import { StringFieldFromJSON, StringFieldToJSON, } from './StringField';
/**
 * Check if a given object implements the SDSection interface.
 */
export function instanceOfSDSection(value) {
    let isInstance = true;
    return isInstance;
}
export function SDSectionFromJSON(json) {
    return SDSectionFromJSONTyped(json, false);
}
export function SDSectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'incassoFondi': !exists(json, 'incassoFondi') ? undefined : CheckboxFieldFromJSON(json['incassoFondi']),
        'billPayment': !exists(json, 'billPayment') ? undefined : CheckboxFieldFromJSON(json['billPayment']),
        'posTerminalsTab1': !exists(json, 'posTerminalsTab1') ? undefined : (json['posTerminalsTab1'].map(PosTerminalFromJSON)),
        'billPaymentAndAcquiring': !exists(json, 'billPaymentAndAcquiring') ? undefined : CheckboxFieldFromJSON(json['billPaymentAndAcquiring']),
        'posTerminalsTab2': !exists(json, 'posTerminalsTab2') ? undefined : (json['posTerminalsTab2'].map(PosTerminalFromJSON)),
        'posBuyOptionTab1': !exists(json, 'posBuyOptionTab1') ? undefined : RadioboxFieldFromJSON(json['posBuyOptionTab1']),
        'posRentalOptionTab1': !exists(json, 'posRentalOptionTab1') ? undefined : RadioboxFieldFromJSON(json['posRentalOptionTab1']),
        'posTidOptionTab1': !exists(json, 'posTidOptionTab1') ? undefined : RadioboxFieldFromJSON(json['posTidOptionTab1']),
        'posBuyOptionTab2': !exists(json, 'posBuyOptionTab2') ? undefined : RadioboxFieldFromJSON(json['posBuyOptionTab2']),
        'posRentalOptionTab2': !exists(json, 'posRentalOptionTab2') ? undefined : RadioboxFieldFromJSON(json['posRentalOptionTab2']),
        'posTidOptionTab2': !exists(json, 'posTidOptionTab2') ? undefined : RadioboxFieldFromJSON(json['posTidOptionTab2']),
        'pagoPaCashMCTC': !exists(json, 'PagoPaCashMCTC') ? undefined : StringFieldFromJSON(json['PagoPaCashMCTC']),
        'pagoPaEmoneyMCTC': !exists(json, 'PagoPaEmoneyMCTC') ? undefined : StringFieldFromJSON(json['PagoPaEmoneyMCTC']),
        'pagoPaCashPRA': !exists(json, 'PagoPaCashPRA') ? undefined : StringFieldFromJSON(json['PagoPaCashPRA']),
        'pagoPaEmoneyPRA': !exists(json, 'PagoPaEmoneyPRA') ? undefined : StringFieldFromJSON(json['PagoPaEmoneyPRA']),
        'pagoPaCashCarTax': !exists(json, 'PagoPaCashCarTax') ? undefined : StringFieldFromJSON(json['PagoPaCashCarTax']),
        'pagoPaEmoneyCarTax': !exists(json, 'PagoPaEmoneyCarTax') ? undefined : StringFieldFromJSON(json['PagoPaEmoneyCarTax']),
        'carTaxCash': !exists(json, 'CarTaxCash') ? undefined : StringFieldFromJSON(json['CarTaxCash']),
        'carTaxEmoney': !exists(json, 'CarTaxEmoney') ? undefined : StringFieldFromJSON(json['CarTaxEmoney']),
        'pagoPaMCTCCost': !exists(json, 'PagoPaMCTCCost') ? undefined : StringFieldFromJSON(json['PagoPaMCTCCost']),
        'pagoPaPRACost': !exists(json, 'PagoPaPRACost') ? undefined : StringFieldFromJSON(json['PagoPaPRACost']),
        'pagoPaCarTaxCost': !exists(json, 'PagoPaCarTaxCost') ? undefined : StringFieldFromJSON(json['PagoPaCarTaxCost']),
        'carTaxCost': !exists(json, 'CarTaxCost') ? undefined : StringFieldFromJSON(json['CarTaxCost']),
        'serviceActivationCost': !exists(json, 'ServiceActivationCost') ? undefined : StringFieldFromJSON(json['ServiceActivationCost']),
        'subscriptionFee': !exists(json, 'SubscriptionFee') ? undefined : StringFieldFromJSON(json['SubscriptionFee']),
        'gatewayCost': !exists(json, 'GatewayCost') ? undefined : StringFieldFromJSON(json['GatewayCost']),
        'sideBurns': !exists(json, 'SideBurns') ? undefined : StringFieldFromJSON(json['SideBurns']),
        'sIMCard': !exists(json, 'SIMCard') ? undefined : StringFieldFromJSON(json['SIMCard']),
        'terminalActivation': !exists(json, 'TerminalActivation') ? undefined : StringFieldFromJSON(json['TerminalActivation']),
        'maintenance': !exists(json, 'Maintenance') ? undefined : StringFieldFromJSON(json['Maintenance']),
        'uninstallationCosts': !exists(json, 'UninstallationCosts') ? undefined : StringFieldFromJSON(json['UninstallationCosts']),
        'failureReturn': !exists(json, 'FailureReturn') ? undefined : StringFieldFromJSON(json['FailureReturn']),
        'onboarding': !exists(json, 'Onboarding') ? undefined : StringFieldFromJSON(json['Onboarding']),
        'failureToUpdate': !exists(json, 'FailureToUpdate') ? undefined : StringFieldFromJSON(json['FailureToUpdate']),
        'companyDamage': !exists(json, 'CompanyDamage') ? undefined : StringFieldFromJSON(json['CompanyDamage']),
    };
}
export function SDSectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'incassoFondi': CheckboxFieldToJSON(value.incassoFondi),
        'billPayment': CheckboxFieldToJSON(value.billPayment),
        'posTerminalsTab1': value.posTerminalsTab1 === undefined ? undefined : (value.posTerminalsTab1.map(PosTerminalToJSON)),
        'billPaymentAndAcquiring': CheckboxFieldToJSON(value.billPaymentAndAcquiring),
        'posTerminalsTab2': value.posTerminalsTab2 === undefined ? undefined : (value.posTerminalsTab2.map(PosTerminalToJSON)),
        'posBuyOptionTab1': RadioboxFieldToJSON(value.posBuyOptionTab1),
        'posRentalOptionTab1': RadioboxFieldToJSON(value.posRentalOptionTab1),
        'posTidOptionTab1': RadioboxFieldToJSON(value.posTidOptionTab1),
        'posBuyOptionTab2': RadioboxFieldToJSON(value.posBuyOptionTab2),
        'posRentalOptionTab2': RadioboxFieldToJSON(value.posRentalOptionTab2),
        'posTidOptionTab2': RadioboxFieldToJSON(value.posTidOptionTab2),
        'PagoPaCashMCTC': StringFieldToJSON(value.pagoPaCashMCTC),
        'PagoPaEmoneyMCTC': StringFieldToJSON(value.pagoPaEmoneyMCTC),
        'PagoPaCashPRA': StringFieldToJSON(value.pagoPaCashPRA),
        'PagoPaEmoneyPRA': StringFieldToJSON(value.pagoPaEmoneyPRA),
        'PagoPaCashCarTax': StringFieldToJSON(value.pagoPaCashCarTax),
        'PagoPaEmoneyCarTax': StringFieldToJSON(value.pagoPaEmoneyCarTax),
        'CarTaxCash': StringFieldToJSON(value.carTaxCash),
        'CarTaxEmoney': StringFieldToJSON(value.carTaxEmoney),
        'PagoPaMCTCCost': StringFieldToJSON(value.pagoPaMCTCCost),
        'PagoPaPRACost': StringFieldToJSON(value.pagoPaPRACost),
        'PagoPaCarTaxCost': StringFieldToJSON(value.pagoPaCarTaxCost),
        'CarTaxCost': StringFieldToJSON(value.carTaxCost),
        'ServiceActivationCost': StringFieldToJSON(value.serviceActivationCost),
        'SubscriptionFee': StringFieldToJSON(value.subscriptionFee),
        'GatewayCost': StringFieldToJSON(value.gatewayCost),
        'SideBurns': StringFieldToJSON(value.sideBurns),
        'SIMCard': StringFieldToJSON(value.sIMCard),
        'TerminalActivation': StringFieldToJSON(value.terminalActivation),
        'Maintenance': StringFieldToJSON(value.maintenance),
        'UninstallationCosts': StringFieldToJSON(value.uninstallationCosts),
        'FailureReturn': StringFieldToJSON(value.failureReturn),
        'Onboarding': StringFieldToJSON(value.onboarding),
        'FailureToUpdate': StringFieldToJSON(value.failureToUpdate),
        'CompanyDamage': StringFieldToJSON(value.companyDamage),
    };
}
